import userFavoriteReducer from "./reducers";

export default userFavoriteReducer;